import Component from './Component';
import Observer from "../utils/ObserverIntersection";
import AddToCartComponent from './AddToCartComponent';
import TagManagerComponent from './TagManagerComponent';
import FacetStorageComponent from "./FacetStorageComponent";
import ModalComponent from './ModalComponent';
import FavouriteComponent from './FavouriteComponent';
import {FFUtils} from "../utils/ff/FFUtils";

export default class InfiniteScrollComponent extends Component {
    get SELECTORS() {
        return {
            main: '.js-infinitescroll',
            trigger: '.js-start-scroll',
            singleResultTemplate: 'single-results--template',
            facetsTemplate: 'facets--template',
            listDom: '.hits',
            facetsDom: '.facets',
            dataOptions: 'data-options',
            backToTopButton: '.js-back-to-top',
            backToTopCtn : ".back-to-top",
            sentinelBackToTop: '.js-trigger-backtotop',
            articleTemplate: 'article--template',
            removeFacet: '.js-facet-remove'
        }
    }

    get CLASSES() {
        return {
            hide: 'hide'
        }
    }

    get DATA() {
        return {
            magazine: 'data-magazine',
            composite: 'data-composite'
        }
    }

    constructor() {
        super();
        this.AddToCartComponent = new AddToCartComponent();
        this.TagManagerComponent = new TagManagerComponent();
        this.FacetStorageComponent = new FacetStorageComponent();
        this.ModalComponent = new ModalComponent();
        this.FavouriteComponent = new FavouriteComponent();
        this.newSearchOptions = FFUtils.OPTIONS;
    }

    observeScrollTrigger() {
        this.scrollObserver = new Observer(this.SELECTORS.main, 0, null, (entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    let options = this.getDataAttribute(this.SELECTORS.main, this.SELECTORS.dataOptions);
                    let jsonOptions = JSON.parse(options);
                    if(jsonOptions.currentpage < (parseInt(jsonOptions.numberofpage) - 1) ) {
                        this.getResultsFacetsAndProducts(jsonOptions);
                    }
                } 
            });
        });
    }

    renderMustacheProducts(templateId, selectorClass, response) {
        let template = document.getElementById(templateId).innerHTML;
        document.querySelector(selectorClass).insertAdjacentHTML('beforeend', this.mustache.render(template, response) );
    }

    updateInfiniteScrollParam(param, url, urlafter) {
        const main = document.querySelector(this.SELECTORS.main);
        let newUrl = url;

        if(url.includes('?')) {
            newUrl = url.split('?')[1];  
        }
        else if(url === ''){
            let options = this.getDataAttribute(this.SELECTORS.main, this.SELECTORS.dataOptions);
            let jsonOptions = JSON.parse(options);
            newUrl = jsonOptions.currentquery;
        }

        const newObj = {
            "currentquery" : newUrl,
            "currentqueryafter" : urlafter,
            "currentpage" : param.currentPage,
            "numberofpage" : param.numberOfPages,
            "pagesize" : param.pageSize
        };
        main.setAttribute('data-options', JSON.stringify(newObj));
    }

    getResultsFacetsAndProducts(obj) {
        const urlPage = "&page="+ (parseInt(obj.currentpage) + 1);
        const isComposite = (!!this.getDataAttribute(this.SELECTORS.facetsDom, this.DATA.composite)) ? '&compositeSearch=' + this.getDataAttribute(this.SELECTORS.facetsDom, this.DATA.composite) : '&compositeSearch=false';
        const isFacet = (document.querySelectorAll(this.SELECTORS.removeFacet).length > 0) ? '&facet=true' : '&facet=false';
        const urlEndopointsFacetsandProducts = obj.currentqueryafter + this.endpoints.INFINITE_SCROLL_FACETS_RESULTS.url + obj.currentquery + urlPage + isFacet + isComposite;
        
        fetch(urlEndopointsFacetsandProducts, {
            headers: {
                'Content-Type': 'application/json', // This is set on request
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                if(this.getDataAttribute(this.SELECTORS.facetsDom, this.DATA.magazine)) {
                    this.renderMustacheProducts(this.SELECTORS.articleTemplate,this.SELECTORS.listDom, data);
                    this.FavouriteComponent.getFavouriteArticles();
                }
                else {
                    this.renderMustacheProducts(this.SELECTORS.singleResultTemplate,this.SELECTORS.listDom, data);
                    this.AddToCartComponent.checkProductsAddedToCartInPage();
                    this.TagManagerComponent.dataLayerImpressionsGA4(data);
                }
                // this.renderMustache(this.SELECTORS.facetsTemplate,document.querySelector(this.SELECTORS.facetsDom), data);
                this.updateInfiniteScrollParam(data.pagination, obj.currentquery, obj.currentqueryafter);
                document.querySelector(this.SELECTORS.backToTopCtn).classList.remove(this.CLASSES.hide);
                this.FacetStorageComponent.set(data.pagination, obj.currentquery, obj.currentqueryafter, null);  
            }
        })
    }

    observeBackToTopTrigger() {            
        let previousY = 0,
        previousRatio = 0;
    
        this.scrollObserver = new Observer(this.SELECTORS.sentinelBackToTop, 0, null, (entries, observer) => {
            entries.forEach(entry => {
                const currentY = entry.boundingClientRect.top, // entry.boundingClientRect.top = entry.boundingClientRect.y (for IE11)
                currentRatio = entry.intersectionRatio,
                isIntersecting = entry.isIntersecting;

                // Scrolling down/up
                if (currentY < previousY) {
                    if (currentRatio > previousRatio && isIntersecting) {
                        document.querySelector(this.SELECTORS.backToTopCtn).classList.remove(this.CLASSES.hide);
                    }
                } else if (currentY > previousY) {
                    if (currentRatio < previousRatio && !isIntersecting) {
                        document.querySelector(this.SELECTORS.backToTopCtn).classList.add(this.CLASSES.hide);   
                    }
                }
                previousY = currentY;
                previousRatio = currentRatio;
            });
        });
    }

    bindEvents() {
        document.querySelector(this.SELECTORS.backToTopButton).addEventListener('click', (e) => {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        })

        this.observeScrollTrigger();

        this.observeBackToTopTrigger();

        document.querySelector('body').addEventListener('click', ()=>{
            localStorage.setItem('scrollY', window.pageYOffset);
        });
    }

    render() {
        const magazine = document.querySelector(this.SELECTORS.facetsDom).getAttribute(this.DATA.magazine) === 'true';
        if (this.newSearchOptions.newSearchOn === 'true' && !magazine) {
            return;
        }
        this.log('render InfiniteScroll');
        if (!document.location.search.includes('databack=true') || localStorage.facet == '') {
            this.bindEvents();
        }
    }
}
